import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useDispatch, useSelector } from 'react-redux';
import { DISABLE_POSTHOG, DISABLE_POSTHOG_REVERSE_PROXY } from '../constants/features/constants';
import { useFeature } from '../components/hooks/isFeatureEnabled';
import { trackEventInPostHogRemote } from '../support-and-tracking/analytics-actions';
import { doesUserConsentToStatistics } from '../user/consents/consent-reducer';

const usePostHog = () => {
    const consentedToStatistics = useSelector((state) => doesUserConsentToStatistics(state));
    const isPostHogDisabled = useFeature(DISABLE_POSTHOG);
    const isPostHogReverseProxyDisabled = useFeature(DISABLE_POSTHOG_REVERSE_PROXY);
    const { distinctId, trackingId, trackingHost, reverseProxyTrackingHost, uiHost, features } = useSelector(
        (state) => state.postHog
    );

    const unleashFeatures = useSelector((state) => state.features);
    const hasFetchedFeatures = useSelector((state) => state.features.hasFetchedFeatures);
    const dispatch = useDispatch();

    const trackEventsFromBeforeAnalyticsStart = () => {
        if (window?.posthogEventsBuffer?.length > 0) {
            while (window.posthogEventsBuffer.length > 0) {
                const event = window.posthogEventsBuffer.shift();
                trackEventInPostHogRemote(event.eventName, event.properties);
            }
        }
    };

    useEffect(() => {
        if (!consentedToStatistics || !trackingId || isPostHogDisabled || !hasFetchedFeatures || !distinctId) {
            return;
        }

        posthog.init(trackingId, {
            api_host: isPostHogReverseProxyDisabled ? trackingHost : reverseProxyTrackingHost,
            bootstrap: {
                distinctID: distinctId,
                featureFlags: { ...(features || {}), ...(unleashFeatures || {}) },
            },
            person_profiles: 'identified_only',
            capture_pageview: false,
            capture_heatmaps: true,
            autocapture: false,
            disable_session_recording: true,
            capture_pageleave: true,
            advanced_disable_feature_flags: true,
            advanced_disable_feature_flags_on_first_load: true,
            ui_host: uiHost,
            loaded: () => {
                dispatch({ type: 'POSTHOG_LOADED' });
            },
        });

        trackEventsFromBeforeAnalyticsStart();
    }, [
        dispatch,
        distinctId,
        features,
        trackingId,
        trackingHost,
        consentedToStatistics,
        isPostHogDisabled,
        isPostHogReverseProxyDisabled,
        reverseProxyTrackingHost,
        uiHost,
        hasFetchedFeatures,
    ]);
};
export default usePostHog;
